import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const LabsFilled: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 16)} fill="none">
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.8515 1.52507C5.8515 1.23508 6.08658 1 6.37657 1H10.2271C10.5171 1 10.7521 1.23508 10.7521 1.52507C10.7521 1.81506 10.5171 2.05014 10.2271 2.05014H9.91421V5.22649C9.91421 5.56582 10.0209 5.89916 10.223 6.19303L14.2894 12.0996C15.1766 13.3883 14.0675 14.9992 12.2933 14.9992H4.30837C2.53414 14.9992 1.42508 13.3883 2.3122 12.0996L6.37859 6.19303C6.58073 5.89916 6.6872 5.56582 6.6872 5.22649V2.05014H6.37657C6.08658 2.05014 5.8515 1.81506 5.8515 1.52507ZM3.86267 12.4365L5.74183 9.39923H10.8595L12.7387 12.4366C13.0586 12.9535 12.6587 13.5998 12.019 13.5998H4.58234C3.94263 13.5998 3.54281 12.9535 3.86267 12.4365Z"
                fill={props.color}
            />
        </Svg>
    );
};

export default React.memo(LabsFilled);
